
export const key = 'cvJY15YykIx2Yox-i';

export default key;